<script context='module'>
  import { setupI18n } from './services/i18n'
  setupI18n()
</script>
<script>
  import Home from "./pages/Home.svelte";
  import Login from "./pages/Login.svelte";
  import Vendors from './pages/Vendors.svelte';
  import Rates from './pages/Rates.svelte';
  import Orders from './pages/Orders.svelte';
  import OrderEdit from './pages/OrderEdit.svelte';
  import Tutorial from './pages/Tutorial.svelte';
  import Page404 from './pages/Page404.svelte';
  import About from './pages/About.svelte';
  import DataProtection from './pages/DataProtection.svelte';
  import Images from './pages/Images.svelte';
  import Logos from './pages/Logos.svelte';
  import Library from './pages/Library.svelte';
  import ColorSchemes from './pages/ColorSchemes.svelte';
  
  import Protected from './components/Protected.svelte'
  import MessageAlert from './components/MessageAlert.svelte'
  import Loading from './components/Loading.svelte'
  import ModalCancelAccept from './components/ModalCancelAccept.svelte'
  import Navigator from './components/Navigator.svelte'
  
  import Router, { location } from 'svelte-spa-router'
  import wrap from 'svelte-spa-router/wrap'

  import OrderReport from './pages/OrderReport.svelte'

  import VrOrders from './pages/VROrders.svelte';

  import Composition from './components/tutorial/Composition.svelte'
  import Order from './components/tutorial/Orders.svelte'

  import { applyColorScheme } from './services/colorScheme';

  applyColorScheme("application");

  const routes = {
    "/": wrap({
      component: Protected,
      props: {
        component: Home,
        acls: []
      }
    }),
    "/login": Login,
    "/vendors": wrap({
      component: Protected,
      props: {
        component: Vendors,
        acls: ['manageUsers']
      }
    }),
    "/rates": wrap({
      component: Protected,
      props: {
        component: Rates,
        acls: ['manageRate']
      }
    }),
    "/logos": wrap({
      component: Protected,
      props: {
        component: Logos,
        acls: ['reportLogo','appLogo']
      }
    }),
    "/colorSchemes": wrap({
      component: Protected,
      props: {
        component: ColorSchemes,
        acls: ['appColors','reportColors']
      }
    }),
    "/orders": wrap({
      component: Protected,
      props: {
        component: Orders,
        acls: ['orderList'],
        type: 'order'
      }
    }),
    "/orderEdit": wrap({
      component: Protected,
      props: {
        component: OrderEdit,
        acls: ['orderGeneration']
      }
    }),
    "/orderEdit/add/:addItemId": wrap({
      component: Protected,
      props: {
        component: OrderEdit,
        acls: ['orderGeneration']
      }
    }),
    "/budgets": wrap({
      component: Protected,
      props: {
        component: Orders,
        acls: ['budgetList'],
        type: 'budget'
      }
    }),
    "/order/:orderId": wrap({
      component: OrderReport
    }),
    "/tuto": Tutorial,
    "/composition": Composition,
    "/order": Order,
    "/about": About,
    "/data-protection": DataProtection,
    "/images": wrap({
      component: Protected,
      props: {
        component: Images,
        acls: ['uploadImages']
      }
    }),
    "/vr-orders": wrap({
      component: Protected,
      props: {
        component: VrOrders,
        acls: ['orderList']
      }
    }),
    "/index": wrap({
      component: Protected,
      props: {
        component: Home,
        acls: []
      }
    }),
    "/library": wrap({
      component: Protected,
      props: {
        component: Library,
        acls: ['libraryEdit']
      }
    }),
    "*": Page404
  }

  let notNavigatorPaths = ['/order/', '/tuto']

</script>
<main>
  <Router {routes}/>
  <MessageAlert/>
  <ModalCancelAccept/>
  <Loading>
    <img src="/img/loading.gif" alt="gifLoader"/>
  </Loading>
</main>
{#if !notNavigatorPaths.some(path => $location.startsWith(path))}
<Navigator/>
{:else}
<style>
  body {
    --body-template: 1fr;
  }
</style>
{/if}

<style>
  main {
    width: 100%;
    height: 100%;
  }
</style>